/**
 * This file defines the Vuex store for application state management.
 *
 * The state contains loggedIn and isAdmin variables that indicate login status and user role.
 * The setLoggedIn and setRole mutations are used to update these variables and synchronize with localStorage.
 */

import { createStore } from 'vuex';

export default createStore({
  state: {
    loggedIn: !!localStorage.getItem('token'),
    isAdmin: localStorage.getItem('role') === 'admin',
  },
  mutations: {
    setLoggedIn(state, value) {
      if (value) {
        const token = value;
        state.loggedIn = true;
        localStorage.setItem('token', token);
      } else {
        state.loggedIn = false;
        localStorage.removeItem('token');
      }
    },
    setRole(state, value) {
      state.isAdmin = value === 'admin';
      if (value) {
        localStorage.setItem('role', value);
      } else {
        localStorage.removeItem('role');
      }
    },
  },
  actions: {},
  getters: {
    isAdmin: state => state.isAdmin,
    loggedIn: state => state.loggedIn
  },
});

